import { connect, type MapStateToProps } from 'react-redux';
import { submit, formValueSelector, type FormStateMap } from 'redux-form';
import type { Dispatch } from 'redux';
import { travelerForm } from '@eti/travelers';
import { CONTACT_INFO_FORM_SECTION, contactFields } from '../../constants/formFields';
import { type Country, type Traveler } from '../../models';
import InfoReviewModal from './InfoReviewModal';

const { EMAIL, PHONE, PHONE_COUNTRY_ID } = contactFields;

interface StateProps {
  form: FormStateMap;
}

interface ConnectedProps {
  contactInfo: { email: string; phone: string; phoneCountry: number };
}

interface InfoReviewModalContainerProps {
  countries: Country[];
  dispatch: Dispatch;
  form: string;
  isOpen: boolean;
  setIsOnSectionOne: (arg: boolean) => void;
  setShowInfoReviewModal: (arg: boolean) => void;
  travelers: Traveler[];
}

const transformTravelers = (form: string, state: StateProps, travelers: Traveler[]) => {
  return travelers.map((traveler, index) => {
    const { ageType } = traveler;
    const firstName = travelerForm.getSelectedFirstName(form)(state, index);
    const lastName = travelerForm.getSelectedLastName(form)(state, index);

    return {
      ageType,
      firstName,
      lastName,
    };
  });
};

const InfoReviewModalContainer = ({
  contactInfo,
  countries,
  dispatch,
  form,
  isOpen,
  setIsOnSectionOne,
  setShowInfoReviewModal,
  travelers,
}: InfoReviewModalContainerProps & ConnectedProps) => {
  const handleSubmit = () => {
    dispatch(submit(form));
  };

  return (
    <InfoReviewModal
      contactInfo={contactInfo}
      countries={countries}
      isOpen={isOpen}
      onSubmit={handleSubmit}
      setIsOnSectionOne={setIsOnSectionOne}
      setShowInfoReviewModal={setShowInfoReviewModal}
      travelers={travelers}
    />
  );
};

const mapStateToProps: MapStateToProps<
  ConnectedProps,
  InfoReviewModalContainerProps,
  StateProps
> = (state: StateProps, { form, travelers }) => {
  const getFormValue = formValueSelector(form);
  const email = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${EMAIL}`);
  const phone = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE}`);
  const phoneCountry = getFormValue(state, `${CONTACT_INFO_FORM_SECTION}.${PHONE_COUNTRY_ID}`);

  return {
    travelers: transformTravelers(form, state, travelers),
    contactInfo: { email, phone, phoneCountry },
  };
};

export default connect(mapStateToProps)(InfoReviewModalContainer);
